import { useEffect } from "react";
import styled, { keyframes } from "styled-components";
import Background from "./Background";
import astronautSrc from "../../img/astronaut.png";
import { Text } from "../../components/Text";
import { Link } from "react-router-dom";

const float = keyframes`
  0% {
    transform: translate3d(0,0,0);
  }
  50% {
    transform: translate3d(0,-30px,0);
  }
  100% {
    transform: translate3d(0,0,0);
  }
`;

const numberAnims = [-32, 10, 40].map(
  (x) => keyframes`
  0% {
    transform: translate3d(0,0,0) rotate(${x}deg);
  }
  50% {
    transform: translate3d(0, -10px, 0) rotate(${x}deg);
  }
  100% {
    transform: translate3d(0,0,0) rotate(${x}deg);
  }
`
);

const rotateAnim = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Astronaut = styled.img`
  max-width: 100%;
  animation: ${float} 7s ease-in-out infinite;
`;

const Number = styled.p`
  color: #333;
  font-size: 128px;
  position: absolute;
  text-shadow: 3px 3px 3px rgba(255, 255, 255, 0.4);
  font-weight: 600;

  & > span {
    display: block;
  }

  &:nth-child(1) {
    top: 5%;
    left: 60%;
    animation: ${numberAnims[0]} 5s ease-in-out infinite;

    & > span {
      animation: ${rotateAnim} 50s linear infinite;
    }
  }

  &:nth-child(2) {
    top: 1%;
    left: 79%;
    animation: ${numberAnims[1]} 4s ease-in-out infinite;

    & > span {
      animation: ${rotateAnim} 40s linear infinite;
    }
  }

  &:nth-child(3) {
    top: 3%;
    left: 97%;
    animation: ${numberAnims[2]} 6s ease-in-out infinite;

    & > span {
      animation: ${rotateAnim} 25s linear infinite;
      animation-direction: reverse;
    }
  }
`;

Astronaut.defaultProps = {
  src: astronautSrc
};

const AstronautContainer = styled.div`
  position: relative;
  width: 50%;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: center;
`;

const NotFound = () => {
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = null;
    };
  }, []);

  return (
    <Container>
      <Background />
      <AstronautContainer>
        <Astronaut />
        <div>
          <Number>
            <span>4</span>
          </Number>
          <Number>
            <span>0</span>
          </Number>
          <Number>
            <span>4</span>
          </Number>
        </div>
      </AstronautContainer>
      <Text>
        <Link
          to="/"
          style={{
            color: "white",
            fontSize: "22px"
          }}
        >
          Back to the App
        </Link>
      </Text>
    </Container>
  );
};

export default NotFound;
